
import React from 'react';
import './ToastContainer.css';
import { Toast } from '../../context/ToastContext';

interface Props {
  toasts: Toast[];
  removeToast: (id: string) => void;
}

const icons: Record<string, string> = {
  success: '✓',
  error: '✕',
  info: 'ℹ',
  warning: '⚠',
};

export default function ToastContainer({ toasts, removeToast }: Props) {
  return (
    <div className="toast-container">
      {toasts.map(t => (
        <div key={t.id} className={`toast toast--${t.type}`}>
          <span className="toast__icon">{icons[t.type]}</span>
          <span className="toast__msg">{t.message}</span>
          <button className="toast__close" onClick={() => removeToast(t.id)}>✕</button>
        </div>
      ))}
    </div>
  );
}
